import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import {
  getCategoryList,
  getGroupSelectArray,
  createRemider,
  getMyReminders,
  updateReminderStatus,
  getReminderCategoryList
} from "../store/myreminder";
import { getRowDetailsFromCustomerId, getAllReminders } from "../store/mycustomers"
import { getBrokerTeamInfo, getBrokerTeamMembers } from "../store/quotes";
import { getQuotes, getMyQuotes } from "../store/myquotes";
import { getBinders, getMyBinders } from "../store/mybinder";
import {
  Popover,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  makeStyles,
  Box,
  Switch
} from "@material-ui/core";
import { Button } from "react-bootstrap";
import { getBrokerInformation } from "../store/broker";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  setautoreminder,
  getAutoreminderState,
  reminderModalSet,
  getReminderModalState,
} from "../store/components";
import { useLocation } from "react-router-dom";
import translations from "../utils/translations";
import frLocale from "date-fns/locale/fr";
import enLocale from "date-fns/locale/en-US";
import DateFnsUtils from "@date-io/date-fns";
import { parseISO, startOfDay, format, isValid } from "date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
export const AddReminderPopUp = ({
  setshowAddReminder,
  showAddReminder,
  manualReminder,
  AutoreminderObj,
  setmanualReminder,
  classes
}) => {
  const categoryListRex = useSelector(getCategoryList);
  let defaultReminderCat = categoryListRex.find(x => x.title['en'] == AutoreminderObj?.remindercategory?.['en'])
  const [formValues, setFormValues] = useState({
    ...AutoreminderObj,
    client: "",
    emailNotification: "Yes",
    thisProspect: "Yes",
    remindertype: "prospect",
    ownertype: AutoreminderObj.ownertype || "Me",
    reminderdate: AutoreminderObj.reminderdate || new Date(),
    remindercategory: defaultReminderCat?.code,
  });
  const [autoTriggerNotifaction, setautoTriggerNotifaction] = useState(
    !manualReminder
  );
  const [showReminderBody, setshowReminderBody] = useState(manualReminder);
  const dispatch = useDispatch();
  const teamList = useSelector(getGroupSelectArray);
  const brokerteam = useSelector(getBrokerTeamMembers);
  const prospectArray = useSelector(getQuotes);
  const binderPolicyArray = useSelector(getBinders);
  const prospects = prospectArray?.prospectorder;
  const binders = binderPolicyArray?.prospectorder;
  const [allClients, setallClients] = useState([]);
  const { information } = useSelector(getBrokerInformation);
  const languagepreference = information?.languagepreference;
  const reminderModalTranslation =
    translations[languagepreference]?.reminderModal;
  const [ownerList, setownerList] = useState([]);
  const [categoryList, setcategoryList] = useState([]);
  const { pathname, search } = useLocation();
  const locale = languagepreference === "fr" ? frLocale : enLocale;
  
  let customerDetails = null;
  var customerid = null;
  let prospectstoFilter = null;
  if(pathname == '/customer'){
    customerid = new URLSearchParams(search).get("id");
  }
  else if( ['/questions', '/quotes', '/sti' ].includes(pathname) ){
    let prospectid =  new URLSearchParams(search).get("id");
    prospectstoFilter = [prospectid]
  }
  customerDetails = useSelector(getRowDetailsFromCustomerId({ customerid }));

  useEffect(() => {
    if (prospects  && !customerDetails) {
      let binderSafe = binders || []
      if(prospectstoFilter){
        setallClients([
          ...prospects.filter(x => prospectstoFilter.includes(x.prospectid)).map((x) => ({
            name: `${x.CLIENT_NAME} - ${x.CLIENT_BUSINESS_NAME}`,
            value: x.prospectid,
          })),
          ...binderSafe.filter(x => prospectstoFilter.includes(x.prospectid)).map((x) => ({
            name: `${x.CLIENT_NAME} - ${x.CLIENT_BUSINESS_NAME}`,
            value: x.prospectid,
          })),
        ]);
      } 
      else {
        setallClients([
          ...prospects.map((x) => ({
            name: `${x.CLIENT_NAME} - ${x.CLIENT_BUSINESS_NAME}`,
            value: x.prospectid,
          })),
          ...binderSafe.map((x) => ({
            name: `${x.CLIENT_NAME} - ${x.CLIENT_BUSINESS_NAME}`,
            value: x.prospectid,
          })),
        ]);
      }
    }
    else if (prospects && binders && customerDetails && customerDetails.prospectids){
      // filter customer selection to just customer when in customer page
      prospectstoFilter = customerDetails.prospectids;
      setallClients([
        ...prospects.filter(x => prospectstoFilter.includes(x.prospectid)).map((x) => ({
          name: `${x.CLIENT_NAME} - ${x.CLIENT_BUSINESS_NAME}`,
          value: x.prospectid,
        })),
        ...binders.filter(x => prospectstoFilter.includes(x.prospectid)).map((x) => ({
          name: `${x.CLIENT_NAME} - ${x.CLIENT_BUSINESS_NAME}`,
          value: x.prospectid,
        })),
      ]);

    }
  }, [prospects, binders, customerDetails]);

  useEffect(() => {
    let code = information.brokeragecode;
    dispatch(getBrokerTeamInfo({ brokeragecode: code }));
  }, [information]);

  useEffect(() => {
    console.log("show cate", categoryListRex);
    setcategoryList(
      categoryListRex.map((x) => ({
        name:
          x.title[languagepreference] != ""
            ? x.title[languagepreference]
            : x.title["en"],
        value: x.code,
      }))
    );
  }, [categoryListRex, languagepreference]);

  useEffect(() => {
    let list = [];
    if (["Individual", "individual"].includes(formValues.ownertype)) {
      list = brokerteam.brokers.map((x) => ({
        name: x.firstname + " " + x.lastname,
        value: x._id,
      }));
    } else if (formValues.ownertype === "group") {
      list = teamList.map((x) => ({ name: x.title, value: x._id }));
    } else if (formValues.ownertype === "Me") {
      setFormValues((prev) => ({
        ...prev,
        owner: information._id,
      }));
    }
    setownerList(list);
  }, [teamList, brokerteam, formValues.ownertype]);

  useEffect(() => {
    if(prospects.length == 0) {
      dispatch(getMyQuotes());
      dispatch(getMyBinders({ statusid: '625e922d580769d01b1c2160' }));
    }
  }, [prospects, binders])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOwnerTypeChange = (type) => {
    setFormValues((prev) => ({
      ...prev,
      ownertype: type,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let finalForm = {
      ...formValues,
      sendemail: formValues.emailNotification === "Yes",
      ownertype: formValues.ownertype === "group" ? "group" : "individual",
      languagepreference:languagepreference
    };

    dispatch(createRemider({ reminder: finalForm }));
    if (formValues.update) {
      if (formValues.status !== AutoreminderObj.status) {
        const reminderStatusObj = {
          reminderId: finalForm._id,
          status: formValues.status,
        };
        dispatch(updateReminderStatus(reminderStatusObj));
      }
    }
    if (pathname.includes("reminders")  ) {
      setTimeout(() => {
        dispatch(getMyReminders());
      }, 200);
    }
    if(pathname.includes("customer") && customerDetails?.prospectids){
      setTimeout(() => {
        dispatch(getAllReminders(customerDetails.prospectids));
      }, 800);
    }
    dispatch(reminderModalSet(false));
    dispatch(setautoreminder({}));
  };

  const styles = {
    row: {
      display: "flex",
      alignItems: "center",
      marginBottom: 15,
    },
    label: {
      width: "50%",
      fontWeight: 500,
    },
    buttonGroup: {
      display: "flex",
      gap: "0px",
      width: "100%",
    },
  };
  
  // Parse reminderdate for the date picker
  const parseReminderDate = (date) => {
    if (!date) return null; // Handle null or undefined
    if (date instanceof Date && isValid(date)) {
      return startOfDay(date); // If already a Date object, normalize to start of day
    }
    if (typeof date === "string") {
      const parsed = parseISO(date); // Try parsing as ISO string (YYYY-MM-DD)
      if (isValid(parsed)) {
        return startOfDay(parsed);
      }
    }
    return null; // Return null for invalid dates
  };
  const autoTriggerText =
    AutoreminderObj?.text || reminderModalTranslation.quoteyReminderQuestion;
  const classesLocal = useStyles();
  return (
    <div style={{ padding: 0 }}>
      {/* <Typography variant="h6" gutterBottom style={{ textAlign: "center" }}>
        {reminderModalTranslation.setReminderOrTask}
      </Typography> */}
      <Box className={classes.popoverHeader} mb={2}>
        <Typography 
          variant="subtitle1"
          style={{ 
            textAlign: 'center', 
            fontWeight: 'bold', 
            color: '#1A1A1A' // Dark color (near black)
          }}
        >
          {reminderModalTranslation.setReminderOrTask}
        </Typography>
      </Box>
      <form onSubmit={handleSubmit} style={{'padding':'1.1em'}} > 
        {/* Row: Quotey Question */}
        <div
          style={{
            ...styles.row,
            display: autoTriggerNotifaction ? "flex" : "none",
            justifyContent: "space-around",
          }}
        >
          <Typography style={{ ...styles.label, width: "65%" }}>
            {autoTriggerText}
          </Typography>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              onClick={() => {
                setFormValues({ ...formValues, thisProspect: "Yes" });
                setautoTriggerNotifaction(false);
                setshowReminderBody(true);
              }}
              style={{
                backgroundColor:
                  formValues.thisProspect === "Yes"
                    ? theme.COLORS.secondary_skyblue
                    : "black",
              }}
            >
              {reminderModalTranslation.yes}
            </Button>
            <Button
              onClick={() => {
                setFormValues({ ...formValues, thisProspect: "No" });
                dispatch(reminderModalSet(false));
                setautoTriggerNotifaction(false);
                setshowReminderBody(false);
                dispatch(setautoreminder({}));
              }}
              style={{
                backgroundColor:
                  formValues.thisProspect === "No"
                    ? theme.COLORS.secondary_skyblue
                    : "black",
              }}
            >
              {reminderModalTranslation.no}
            </Button>
          </div>
        </div>
        <div style={{ display: showReminderBody ? null : "none" }}>
          {/* Row: Reminder Title */}
          <div style={styles.row}>
            <Typography style={styles.label}>
              {reminderModalTranslation.reminderTitle}
            </Typography>
            <TextField
              name="title"
              value={formValues.title}
              onChange={handleChange}
              fullWidth
              placeholder={reminderModalTranslation.titlePlaceholder}
            />
          </div>

          {/* Row: Category */}
          <div style={styles.row}>
            <Typography style={styles.label}>
              {reminderModalTranslation.category}
            </Typography>
            <FormControl fullWidth>
              <InputLabel>{reminderModalTranslation.category}</InputLabel>
              <Select
                name="remindercategory"
                value={formValues.remindercategory}
                onChange={handleChange}
              >
                {categoryList.map((x) => (
                  <MenuItem key={x.value} value={x.value}>
                    {x.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          {/* Row: Client */}
          <div style={styles.row}>
            <Typography style={styles.label}>
              {reminderModalTranslation.client}
            </Typography>
            <FormControl fullWidth>
              <Autocomplete
                options={allClients}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={reminderModalTranslation.clientsLabel}
                    fullWidth
                  />
                )}
                value={
                  allClients.find((x) => x.value === formValues.prospectid) ||
                  null
                }
                name="prospectid"
                onChange={(e, newValue) => {
                  let prospectid = newValue?.value || "";
                  setFormValues((prev) => ({
                    ...prev,
                    prospectid,
                  }));
                }}
              />
            </FormControl>
          </div>

          {/* Row: Target Date */}
          <div style={styles.row}>
            <Typography style={styles.label}>
              {reminderModalTranslation.targetDate}
            </Typography>
            {/* <TextField
              name="reminderdate"
              type="date"
              value={formValues.reminderdate}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              
            /> */}

            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                placeholder={
                  languagepreference === "fr" ? "jj/mm/aaaa" : "mm/dd/yyyy"
                }
                cancelLabel={translations[languagepreference].cancel}
                todayLabel={
                  languagepreference === "fr" ? "Aujourd'hui" : "Today"
                }
                // className={classes.datePicker}
                // inputVariant="filled"
                value={parseReminderDate(formValues.reminderdate)}
                format="MM/dd/yyyy"
                fullWidth
                style={{'height':'100%'}}
                InputProps={{
                  style: {
                    fontSize: 17,
                    height: '4vh'
                  }
                }}
                // onChange={handleChange}
                onChange={(newValue) =>
                  // Create a synthetic event to use your handleChange function
                  handleChange({
                    target: { name: "reminderdate", value: newValue },
                  })
                }
              />
            </MuiPickersUtilsProvider>
          </div>

          {/* Row: Owner Type */}
          <div style={styles.row}>
            <Typography style={styles.label}>
              {reminderModalTranslation.ownerType}
            </Typography>
            <div style={styles.buttonGroup}>
              <Button
                onClick={() => handleOwnerTypeChange("Me")}
                style={{
                  backgroundColor:
                    formValues.ownertype === "Me"
                      ? theme.COLORS.secondary_skyblue
                      : "white",
                  color:
                    formValues.ownertype === "Me"
                      ? "white"
                      : "black",
                  width: "33%",
                  fontSize:"14px",
                  borderColor:"96969",
                  borderRadius:0,
                }}
              >
                {reminderModalTranslation.me}
              </Button>
              <Button
                onClick={() => handleOwnerTypeChange("Individual")}
                style={{
                  backgroundColor: ["Individual", "individual"].includes(formValues.ownertype)
                    ? theme.COLORS.secondary_skyblue
                    : "white",
                  color: ["Individual", "individual"].includes(formValues.ownertype)
                      ? "white"
                      : "black",
                  width: "33%",
                  fontSize:"12px",
                  borderRadius:0,
                  borderColor:"96969",
                }}
              >
                {reminderModalTranslation.otherPeople}
              </Button>
              <Button
                onClick={() => handleOwnerTypeChange("group")}
                style={{
                  backgroundColor:
                    formValues.ownertype === "group"
                      ? theme.COLORS.secondary_skyblue
                      : "white",
                  color: formValues.ownertype === "group"
                    ? "white"
                    : "black",
                  width: "33%",
                  fontSize:"14px",
                  borderColor:"96969",
                  borderRadius:0,
                }}
              >
                {reminderModalTranslation.team}
              </Button>
            </div>
          </div>

          {/* Row: Owner */}
          <div
            style={{
              ...styles.row,
              display: formValues.ownertype === "Me" ? "none" : "flex",
            }}
          >
            <Typography style={styles.label}>
              {reminderModalTranslation.owner}
            </Typography>
            <FormControl fullWidth>
              <InputLabel>{reminderModalTranslation.owner}</InputLabel>
              <Select
                name="owner"
                value={formValues.owner}
                onChange={handleChange}
              >
                {ownerList.map((x) => (
                  <MenuItem key={x.value} value={x.value}>
                    {x.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          {/* Row: Description */}
          <div style={styles.row}>
            <Typography style={styles.label}>
              {reminderModalTranslation.description}
            </Typography>
            <TextField
              name="description"
              defaultValue={formValues.description}
              onBlur={handleChange}
              fullWidth
              multiline
              maxRows={4}
            />
          </div>

          {formValues.update && (
            <div style={styles.row}>
              <Typography style={styles.label}>
                {reminderModalTranslation.status}
              </Typography>
              <FormControl fullWidth>
                <Select
                  name="status"
                  value={formValues.status}
                  onChange={handleChange}
                >
                  <MenuItem value="open">
                    {reminderModalTranslation.statusOpen}
                  </MenuItem>
                  <MenuItem value="completed">
                    {reminderModalTranslation.statusCompleted}
                  </MenuItem>
                  <MenuItem value="onhold">
                    {reminderModalTranslation.statusOnHold}
                  </MenuItem>
                  <MenuItem value="other">
                    {reminderModalTranslation.statusOther}
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
          )}

          {/* Row: Email Notification */}
          <div style={{...styles.row, 'justifyContent':'space-between'}}>
            <div style={{width:''}}>
              <Typography style={{ ...styles.label, width: "65%" }}>
                {reminderModalTranslation.sendEmailNotificationToOwner}
              </Typography>
            </div>
            <div style={{ display: "flex", gap: "10px", marginRight:".25vw" }}>
              {/* <Button
                onClick={() =>
                  setFormValues({
                    ...formValues,
                    emailNotification: "Yes",
                  })
                }
                style={{
                  backgroundColor:
                    formValues.emailNotification === "Yes"
                      ? theme.COLORS.secondary_skyblue
                      : "black",
                }}
              >
                {reminderModalTranslation.yes}
              </Button>
              <Button
                onClick={() =>
                  setFormValues({
                    ...formValues,
                    emailNotification: "No",
                  })
                }
                style={{
                  backgroundColor:
                    formValues.emailNotification === "No"
                      ? theme.COLORS.secondary_skyblue
                      : "black",
                }}
              >
                {reminderModalTranslation.no}
              </Button> */}
              <Switch
                classes={{
                  root: classesLocal.root,
                  switchBase: classesLocal.switchBase,
                  thumb: classesLocal.thumb,
                  track: classesLocal.track,
                  checked: classesLocal.checked,
                  focusVisible: classesLocal.focusVisible,
                }}
                checked={formValues.emailNotification === "Yes"}
                onChange={(e) => {
                  console.log(e.target.checked);
                  let answer = e.target.checked ? "Yes" : "No";
                   setFormValues({
                    ...formValues,
                    emailNotification: answer,
                  })
                }}
              />
            </div>
          </div>

          {/* Row: Create/Update Reminder */}
          <div style={{ textAlign: "center", marginTop: 20 }}>
            <Button type="submit" className={classesLocal.submitButton} variant="contained" color="primary">
              {formValues.update
                ? reminderModalTranslation.updateReminder
                : reminderModalTranslation.createReminder}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export const ReminderPopOver = ({
  anchorEl,
  setAnchorEl,
  setshowAddReminder,
  showAddReminder,
}) => {
  const dispatch = useDispatch();
  const [manualReminder, setmanualReminder] = useState(true);
  const isReminderModalStateOpen = useSelector(getReminderModalState);
  console.log("isReminderModalStateOpen: ", isReminderModalStateOpen);
  const useStyles = makeStyles({
    paper: {
      boxShadow: "0px 0px 9px 0px rgba(0,0,0,0.5)",
      width: (props) => (props.width ? `${props.width}px` : "calc(100%-64px)"),
      height: (props) => (props.height ? `${props.height}px` : "100%"),
    },
    popoverHeader: {
      width: '100%', // Ensure full width
      backgroundColor: '#dbd8d8', // Example background color (light gray)
      marginBottom: '16px', // Maintain the mb={2} (2 * 8px = 16px)
      padding: '8px 0', // Optional: Add vertical padding for aesthetics
      borderRadius: '4px 4px 0 0', // Optional: Match popover's top corners
    },
  });
  const classes = useStyles({ height: "100px", width: "100px" });
  const AutoreminderObj = useSelector(getAutoreminderState);
  const { information } = useSelector(getBrokerInformation);
  const languagepreference = information?.languagepreference;
  const reminderModalTranslation =
    translations[languagepreference]?.reminderModal;

  useEffect(() => {
    if (Object.keys(AutoreminderObj).length) {
      console.log("AutoreminderObj has properties!");
      dispatch(reminderModalSet(true));
      setmanualReminder(AutoreminderObj.update ? true : false);
    } else {
      setmanualReminder(true);
    }
  }, [AutoreminderObj]);

  useEffect(() => {
    dispatch(getReminderCategoryList());
  }, [])

  let anchorOrigin = {
    vertical: anchorEl ? "bottom" : "top",
    horizontal: anchorEl ? "left" : "right",
  };

  return (
    <Popover
      id="info"
      open={isReminderModalStateOpen}
      anchorEl={anchorEl}
      onClose={() => {
        console.log("Closed");
        dispatch(reminderModalSet(false));
      }}
      anchorOrigin={anchorOrigin}
      classes={classes}
      onClick={(event) => {
        event.stopPropagation();
      }}
      PaperProps={{
        style: { width: "25%" },
      }}
    >
      <AddReminderPopUp
        setshowAddReminder={setshowAddReminder}
        manualReminder={manualReminder}
        AutoreminderObj={AutoreminderObj}
        setmanualReminder={setmanualReminder}
        classes={classes}
      />
    </Popover>
  );
};


const useStyles = makeStyles({
  root: {
    width: 42*1,
    height: 26*1,
    padding: 0,
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(18px)',
      color: '#fff',
      '& + $track': {
        backgroundColor: theme.COLORS.secondary_skyblue, // Custom checked track color
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 24*1,
    height: 24*1,
    backgroundColor: '#fff', // Custom thumb color
  },
  track: {
    borderRadius: 26 / 2 *2,
    backgroundColor: '#EAEAEA', // Custom unchecked track color
    opacity: 1,
    transition: 'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
  checked: {},
  focusVisible: {},
  submitButton: {
    backgroundColor: "rgb(73, 168, 214)",
    color: "white",
    "&:hover": {
      backgroundColor: "rgb(73, 168, 214)", // Maintain your custom background on hover
      color: "black", // Text turns black on hover
    },
  },
});
